module.exports = __webpack_public_path__ + "static/media/cat-lady5W.aacd6598.png";